
import React, { useEffect, useState } from 'react';
import ConnUrls from '../../Connections/ConnectURL';
import BigPopUpMsg from '../BigPopUpMsg';
import PopUpMsg from '../PopUpMsg';
import PopUpClearComp from '../PopUpClearComp';
import PopUpHappy from '../PopUpHappy';
import PopUpsSlides from '../PopUpsSlides';



const Minimum_Order = (props) => {

    var jumcodeChek = 1;
    useEffect(() => {



    }, [])


    return (
        // <PopUpMsg Title={["מינימום הזמנה"]}
        //     nosnippet={true}
        //     ContentText={[{ txt: "על מנת להזמין משלוח", css: "" },
        //     { txt: "יש לבצע מינימום הזמנה במחיר של", css: "" },
        //     { txt: `${props.mindelP} ₪`, css: "" }]}
        //     inLabel={""}

        //     okClick={() => props.okClick()}

        //     btnClick2={() => { props.btnClick2() }}
        //     cssStyl={"orderOneClose"}
        //     BtnTxt={"חזור לתפריט"}
        //     BtnTxt2={"סגור"}
        //     errorMsg={""} />


        <PopUpClearComp
            popFullComp={"specialPopComp onTopOfAll"}
            cssStyl={"noPadding"}
            btnFStyle={"fatInBtn"}
            // closePop={() => setThePopUp()}
            insideCss={"noPadding"}
            theInsideComp={
                <PopUpHappy key={jumcodeChek}
                    Title={["מינימום הזמנה"]}
                    cssStyl={"okPOP onTopOfAll"}
                    topSlides={<PopUpsSlides key={"logInPop"}
                        TopImages={[{ img: props.master.nowCloseImg, txt: "" }]} />}
                    ContentText={[{ txt: "עסק זה כרגע סגור", css: "" }
                        , { txt: "ולא ניתן לבצע הזמנות", css: "" }]}
                    inLabel={""}
                    okClick1={() => props.okClick1()}
                    okClick2={() => props.okClick2()}
                    okTxt1={"חזור לתפריט"}
                    okTxt2={"סגור"}
                />

            } />

    )
}


export default Minimum_Order;